import { createFileRoute } from "@tanstack/react-router";
import i18n from "i18next";
import { PurchaseOrderDeliveryNoticesPage } from "src/components/views/erp/purchase/deliveryNotices/PurchaseOrderDeliveryNoticesPage.tsx";

export const Route = createFileRoute("/_authenticated/_shell/purchase/deliveryNotices")({
	staticData: { title: i18n.t("delivery_notices"), legacyViewKey: "purchaseOrderDeliveryNoticesPage" },
	component: RouteComponent,
});

function RouteComponent() {
	return <PurchaseOrderDeliveryNoticesPage />;
}
